import { initExpositions } from "./expositions";
import { initCarousel } from "./carousel";
document.addEventListener("DOMContentLoaded", () => {
    initExpositions();
    initCarousel();
});